export { default } from './MessageBar';
export { default as MessageBar } from './MessageBar';
